export const baseurl = "https://api.rfirms.com/v1/rc/web/";
export const imgUrl = "https://api.rfirms.com/";

